import { SchoolDetailsExistsGuard } from './school-details-exists.guard';
import { SchoolSearchResultsGuard } from './school-searchresults.guard';

export const guards: any[] = [SchoolSearchResultsGuard, SchoolDetailsExistsGuard];

export * from './school-details-exists.guard';
export * from './school-searchresults.guard';
